var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kst-loading has-text-centered"},[_c('img',{attrs:{"src":require("@/assets/loading.svg"),"alt":"Loading"}}),_c('p',{staticClass:"is-size-5"},[_vm._v(" "+_vm._s(_vm.theText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }